<template>
  <div>
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div class="addGroupFaculty" v-else>
      <b-form-input v-model="searchText" placeholder="Search by name" size="sm" class="mb-3"></b-form-input>
      <table class="table table-striped table-bordered">
        <thead class="thead-dark text-left">
          <th style="width:40px">
            <input type="checkbox" :checked="allSelectableSelected" @change="toggleSelectAll"
              :disabled="submitBtn.disabled || availableFaculties.length === 0" />
          </th>
          <th style="width:1%;white-space:nowrap">Sl No.</th>
          <th>Name</th>
          <th>Email</th>
        </thead>
        <tbody>
          <tr v-if="availableFaculties.length === 0">
            <td colspan="4" class="text-center">No faculties available</td>
          </tr>
          <tr v-for="(faculty, index) in availableFaculties" :key="faculty.id">
            <td>
              <input type="checkbox" :value="faculty.id" v-model="selectedFacultyIds"
                :disabled="submitBtn.disabled" />
            </td>
            <td>{{ index + 1 }}</td>
            <td>{{ faculty.name }}</td>
            <td>{{ faculty.email }}</td>
          </tr>
        </tbody>
      </table>
      <h6 class="font-weight-bold mb-2">Already Added to a Department</h6>
      <table class="table table-striped table-bordered">
        <thead class="thead-dark text-left">
          <th style="width:1%;white-space:nowrap">Sl No.</th>
          <th>Name</th>
          <th>Email</th>
          <th>Department</th>
        </thead>
        <tbody>
          <tr v-if="assignedFaculties.length === 0">
            <td colspan="4" class="text-center">No faculties added yet</td>
          </tr>
          <tr v-for="(faculty, index) in assignedFaculties" :key="faculty.id">
            <td>{{ index + 1 }}</td>
            <td>{{ faculty.name }}</td>
            <td>{{ faculty.email }}</td>
            <td>{{ existingFaculty[faculty.id] ? groupModal.name : otherDepartmentOf[faculty.id] }}</td>
          </tr>
        </tbody>
      </table>

      <div class="actionBar d-flex justify-content-between align-items-center">
        <span class="text-muted">{{ newlyAddedIds.length }} selected</span>
        <div>
          <b-button variant="secondary" size="sm" class="mr-2" @click="$emit('addFacultyStatus', false)"
            :disabled="submitBtn.disabled">Cancel</b-button>
          <b-button variant="primary" size="sm" @click="enrollFacultyToGroup"
            :disabled="submitBtn.disabled || newlyAddedIds.length === 0">{{ submitBtn.text }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.actionBar {
  position: sticky;
  bottom: 0;
  z-index: 2;
  background: #fff;
  border-top: 1px solid #dee2e6;
  padding: 10px 0;
}
</style>

<script>
export default {
  props: ["groupModal", "listOfUsersEnrolled"],
  async created() {
    this.fetchData = true;
    this.getExistingFacultyObject();
    await Promise.all([this.getFacultyDetails(), this.getFacultiesInOtherDepartments()]);
    this.fetchData = false;
  },
  data() {
    return {
      fetchData: false,
      institutionFaculties: [],
      selectedFacultyIds: [],
      searchText: "",
      existingFaculty: {},
      otherDepartmentOf: {}, // institution_user_id: department name
      submitBtn: {
        text: "Submit",
        disabled: false,
      },
    };
  },
  computed: {
    searchedFaculties() {
      const search = this.searchText.trim().toLowerCase();
      if (!search) return this.institutionFaculties;
      return this.institutionFaculties.filter((f) => f.name.toLowerCase().includes(search));
    },
    availableFaculties() {
      return this.searchedFaculties.filter(
        (f) => !this.existingFaculty[f.id] && !this.otherDepartmentOf[f.id]
      );
    },
    assignedFaculties() {
      return this.searchedFaculties.filter(
        (f) => this.existingFaculty[f.id] || this.otherDepartmentOf[f.id]
      );
    },
    selectableFacultyIds() {
      return this.availableFaculties.map((f) => f.id);
    },
    allSelectableSelected() {
      return this.selectableFacultyIds.length > 0 &&
        this.selectableFacultyIds.every((id) => this.selectedFacultyIds.includes(id));
    },
    newlyAddedIds() {
      return this.selectedFacultyIds.filter((id) => !this.existingFaculty[id]);
    },
  },
  methods: {
    toggleSelectAll(event) {
      if (event.target.checked) {
        const toAdd = this.selectableFacultyIds.filter((id) => !this.selectedFacultyIds.includes(id));
        this.selectedFacultyIds = [...this.selectedFacultyIds, ...toAdd];
      } else {
        this.selectedFacultyIds = this.selectedFacultyIds.filter((id) => !this.selectableFacultyIds.includes(id));
      }
    },
    async enrollFacultyToGroup() {
      if (!this.newlyAddedIds.length) return;
      this.submitBtn = {
        text: "Please wait....",
        disabled: true,
      };
      const facultyData = {
        maingroup_id: this.groupModal.id,
        maingrouprole_id: 2,
        institution_users: this.newlyAddedIds,
      };

      const url = this.$store.getters.getAPIKey.mainAPI + `/maingroupusers`;

      await this.$axios
        .post(url, facultyData)
        .then(() => {
          this.$toast.success(`Users added to ${this.groupModal.name}`, {
            position: "top",
            duration: 3000,
          });
          this.$emit("addFacultyStatus", true);
        })
        .catch((error) => {
          const message = (error.response && error.response.data && error.response.data.message) || "Failed to add faculty";
          this.$toast.error(message, { position: "top", duration: 3000 });
        });
      this.submitBtn = {
        text: "Submit",
        disabled: false,
      };
    },
    async getFacultyDetails() {
      const url = this.$store.getters.getAPIKey.instituitionFaculty;
      await this.$axios
        .get(url)
        .then((response) => {
          this.institutionFaculties = response.data
            .filter((staff) => staff.enroll_status == 'active')
            .map((staff) => ({
              id: staff.id,
              name: [staff.first_name, staff.last_name].filter(Boolean).join(' '),
              email: staff.email,
            }))
            .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));
        })
        .catch(() => {
          this.$toast.error("Failed to load faculties", { position: "top", duration: 3000 });
        });
    },
    async getFacultiesInOtherDepartments() {
      const url = this.$store.getters.getAPIKey.mainAPI +
        `/maingroups/${this.groupModal.id}/faculties/assigned-elsewhere`;
      await this.$axios
        .get(url)
        .then((response) => {
          const map = {};
          response.data.forEach((row) => {
            map[row.institution_user_id] = row.maingroup_name;
          });
          this.otherDepartmentOf = map;
        })
        .catch(() => {});
    },
    getExistingFacultyObject() {
      this.existingFaculty = {};
      this.listOfUsersEnrolled.forEach((faculty) => {
        this.$set(this.existingFaculty, faculty.institution_user_id, true);
      });
    },
  },
};
</script>
